<ui-card [uiBordered]="false" [uiHeadBorderless]="true" [uiRounded]="true" [uiExtra]="extraHeaderContentTemplate">
  <ng-template #extraHeaderContentTemplate>
    <widget-actions [widgetId]="widgetId" [canRemove]="true" (remove)="remove()" />
  </ng-template>

  <read-only-user-message class="widget-view" [widgetView]="true" [hideCloseButton]="true"></read-only-user-message>
</ui-card>
